import React, { useState } from 'react';
import { MapPin, Plus, Trash2, Clock } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент секции управления запланированными остановками
 */
const StopsSection = ({ 
  formData, 
  errors, 
  handleAddStop,
  handleRemoveStop 
}) => {
  const [newStop, setNewStop] = useState({ name: '', duration: '' });

  if (!formData.includeStops) return null;

  // Обработка изменения полей новой остановки
  const handleNewStopChange = (e) => {
    const { name, value } = e.target;
    setNewStop(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Добавление новой остановки
  const addStop = () => {
    if (!newStop.name || !newStop.duration) return;
    
    handleAddStop({
      name: newStop.name,
      duration: newStop.duration
    });
    
    // Сброс формы новой остановки
    setNewStop({ name: '', duration: '' });
  };

  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <MapPin className="w-5 h-5 mr-2 text-blue-500" />
        Запланированные остановки
      </h3>
      
      {/* Форма добавления новой остановки */}
      <div className="flex flex-col md:flex-row gap-3 mb-4">
        <div className="md:flex-grow">
          <input
            type="text"
            name="name"
            value={newStop.name}
            onChange={handleNewStopChange}
            className="form-input w-full"
            placeholder="Название остановки"
          />
        </div>
        <div className="md:w-1/4">
          <input
            type="text"
            name="duration"
            value={newStop.duration}
            onChange={handleNewStopChange}
            className="form-input w-full"
            placeholder="Длит-ть (мин)"
          />
        </div>
        <div>
          <Button
            type="button"
            onClick={addStop}
            disabled={!newStop.name || !newStop.duration}
            icon={<Plus className="w-4 h-4" />}
            size="sm"
          >
            Добавить
          </Button>
        </div>
      </div>

      {/* Список остановок */}
      {formData.stops.length > 0 ? (
        <div className="space-y-2 max-h-60 overflow-y-auto p-1">
          {formData.stops.map((stop, index) => (
            <div 
              key={index} 
              className="flex items-center justify-between p-2 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700"
            >
              <div className="flex items-center">
                <MapPin className="w-4 h-4 text-blue-500 mr-2" />
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{stop.name}</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
                  <Clock className="w-4 h-4 mr-1" />
                  {stop.duration} мин
                </div>
                <button
                  type="button"
                  onClick={() => handleRemoveStop(index)}
                  className="text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-3 text-sm text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-800/50 rounded-lg">
          Добавьте запланированные остановки для отдыха, питания или осмотра достопримечательностей
        </div>
      )}

      {/* Общие ошибки по остановкам */}
      {Object.keys(errors).some(key => key.startsWith('stops[')) && (
        <p className="mt-2 text-xs text-red-500 dark:text-red-400">
          Проверьте корректность введенных данных для остановок
        </p>
      )}

      {/* Советы по планированию остановок */}
      <div className="mt-4 bg-blue-100 dark:bg-blue-900/40 p-3 rounded-lg text-xs text-blue-700 dark:text-blue-300">
        <p>
          <strong>Совет:</strong> Правильно планируйте остановки для комфортной поездки. Для длительных поездок рекомендуются
          остановки каждые 2-3 часа. Учитывайте время на обед (30-60 минут) и осмотр интересных мест.
        </p>
      </div>
    </div>
  );
};

export default StopsSection;